import { BasicEnum } from './../../constants/enums/BasicEnum';
/**
 * Created with IntelliJ IDEA.
 * User: aprzybyszewski
 * Date: 14.06.13
 * Time: 16:51
 * To change this template use File | Settings | File Templates.
 */

export class AgeCheck extends BasicEnum {
    // list of all enumerated values
    private static _values: AgeCheck[] = [];

    // getter for list of all enumerated values
    public static get values(): AgeCheck[] {
        return AgeCheck._values.concat();
    }

    // declaration of enumerated values
    // TODO: add final textIds
    private static _none: AgeCheck = new AgeCheck("None", 0, 0xffffff, 0, "generic_alert_information", BasicEnum.instantiationKey);
    private static _all: AgeCheck = new AgeCheck("All", 1, 0x8CC63F, -1, "generic_alert_information", BasicEnum.instantiationKey);
    private static _overTwelve: AgeCheck = new AgeCheck("OverTwelve", 2, 0x50BBEB, 12, "generic_alert_information", BasicEnum.instantiationKey);
    private static _overFifteen: AgeCheck = new AgeCheck("OverFifteen", 3, 0xFFD200, 15, "generic_alert_information", BasicEnum.instantiationKey);
    private static _overEighteen: AgeCheck = new AgeCheck("OverEighteen", 4, 0xE31B23, 18, "generic_alert_information", BasicEnum.instantiationKey);

    // getters for enumerated values
    public static get None(): AgeCheck {
        return AgeCheck._none;
    }

    public static get All(): AgeCheck {
        return AgeCheck._all;
    }

    public static get OverTwelve(): AgeCheck {
        return AgeCheck._overTwelve;
    }

    public static get OverFifteen(): AgeCheck {
        return AgeCheck._overFifteen;
    }

    public static get OverEighteen(): AgeCheck {
        return AgeCheck._overEighteen;
    }

    // instance variables
    protected _id: number;
    private _backgroundColor: number;
    private _age: number;
    private _textId: string;

    // getter for instance variables
    public get id(): number {
        return this._id;
    }

    /**
     * Colors taken from official Game Rating Board homepage:
     * http://www.grb.or.kr/english/oursymbol.html
     *
     * Color values has been converted from RGB to hex.
     */
    public get backgroundColor(): number {
        return this._backgroundColor;
    }

    public get age(): number {
        return this._age;
    }

    public get textId(): string {
        return this._textId;
    }

    // getByProperty functions
    public static getById(id: number): AgeCheck {
        return (<AgeCheck>this.getByProperty(AgeCheck, "id", id, AgeCheck.None));
    }

    constructor(name: string, id: number, backgroundColor: number, age: number, textId: string, doNotInstantiate: number) {
        super(name, doNotInstantiate);
        this._id = id;
        this._backgroundColor = backgroundColor;
        this._age = age;
        this._textId = textId;

        AgeCheck._values.push(this);
    }
}
